<template>
  <div class="exclusive">
    <div class="exclusive-coupon" v-for="(item, index) in couponList" :key="index">
      <div class="exclusive-top">
        <img :src="item.brand_logo" />
        <div class="exclusive-title">{{ item.title }}</div>
      </div>
      <div
        class="exclusive-btn"
        v-auth:click="{ method: clickCoupon, params: item }"
        :class="{ get: item.is_client == 1 }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    couponList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    clickCoupon(item) {
      this.$emit('clickCoupon', {
        coupon: item,
        params: {
          type: 2,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
 .exclusive{
     background: url(~@this/assets/image-14.png) no-repeat;
     background-size: 100% 100%;
     width: 674px;
     height: 422px;
     padding: 100px 20px 0;
     margin:50px 0;
     display: flex;
     justify-content:space-around;
     flex-wrap: wrap;
     .exclusive-coupon{
     background: url(~@this/assets/image-09.png) no-repeat;
     background-size: 100% 100%;
     width: 307px;
     height: 180px;
     box-sizing: border-box;
     padding: 10px;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: space-around;
     .exclusive-top{
         display: flex;
         justify-content: space-between;
         align-items: center;
         img{
          height: 76px;
          border:3px solid #646eac;
          border-radius: 50%;
          margin-right: 10px;
         }
         .exclusive-title{
             color:  #bfe1e0;
         }
     }
     .exclusive-btn{
       background: url(~@this/assets/image-10.png) no-repeat;
       background-size: 100% 100%;
     width: 178px;
     height: 44px;
     &.get{
       background: url(~@this/assets/image-11.png) no-repeat;
       background-size: 100% 100%;
     }
     }
     }
 }
</style>
